(function(){
'use strict';
if(window.mnbsAppointmentRouting)return;window.mnbsAppointmentRouting=true;
const config=document.currentScript,booking=config?.dataset.bookingUrl||'/pages/book-an-appointment',title=config?.dataset.productTitle||'';
const photoHandles=new Set(['canvas-in','throw-blanket','enhanced-matte-paper-poster-in','mouse-pad']);
const photo=photoHandles.has(location.pathname.split('/products/')[1]?.split('/')[0]);
const upload=()=>Array.from(document.querySelectorAll('#mnbs-design-type,.customily-set select')).some(s=>/^Upload your (photo|design)/i.test(s.value));
const go=()=>{const u=new URL(booking,location.origin);if(title)u.searchParams.set('product',title);location.assign(u.href);};
const stop=e=>{e.preventDefault();e.stopImmediatePropagation();};
window.addEventListener('change',e=>{if(e.target.matches('#mnbs-design-type,.customily-set select')&&/^Upload your (photo|design)/i.test(e.target.value)){stop(e);go();}},true);
window.addEventListener('click',e=>{
const el=e.target instanceof Element?e.target:e.target.parentElement;if(!el)return;
const label=el.closest('.customily-set label');
if(el.closest('.customily-set input[type="file"],.customily-set .cl-file-input,.customily-set .cl-upload-image')||(label?.htmlFor&&document.getElementById(label.htmlFor)?.type==='file')){stop(e);go();return;}
if(el.closest('#customily-cart-btn,button[name="add"],.shopify-payment-button,button[type="submit"]')&&(photo||upload())){stop(e);go();}
},true);
window.addEventListener('submit',e=>{if(e.target.matches('form[action*="/cart/add"]')&&(photo||upload())){stop(e);go();}},true);
function refresh(root){
for(const o of root.querySelectorAll('#mnbs-design-type option,.customily-set select option'))if(/^Upload your (photo|design)/i.test(o.value)&&o.textContent!==config.dataset.uploadLabel)o.textContent=config.dataset.uploadLabel;
for(const a of root.querySelectorAll('a[href*="/collections/create-your-own"]'))a.href=booking;
const p=root.querySelector('#MnbsAppointmentProduct');if(p&&!p.value)p.value=new URLSearchParams(location.search).get('product')||'';
}
function start(){refresh(document);new MutationObserver(rs=>{for(const r of rs)for(const n of r.addedNodes)if(n instanceof Element){if(n.matches('select'))refresh(n.parentElement);else if(n.querySelector('#mnbs-design-type,.customily-set select,a[href*="/collections/create-your-own"],#MnbsAppointmentProduct'))refresh(n);}}).observe(document.body,{childList:true,subtree:true});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
}());
(function () {
  'use strict';
  const query = new URLSearchParams(location.search);
  const template = query.get('mnbs_template');
  const isTemplate = /^[A-E]$/.test(template || '');
  const key = isTemplate ? template : query.get('mnbs_logo');
  if ((!isTemplate && !/^(?:[A-E]|Official)$/.test(key || '')) || !location.pathname.includes('/products/')) return;
  let modeSet = false, done = false, attempts = 0, autoOpened = false, changedAt = 0;
  const change = (input, value) => {
    if (input.value === value) return;
    input.value = value;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };
  const finish = () => {
    done = true;
    clearInterval(timer);
    const url = new URL(location.href);
    url.searchParams.delete('mnbs_logo');
    url.searchParams.delete('mnbs_template');
    history.replaceState(history.state, '', url);
  };
  const onClose = event => {
    if (!(event.target instanceof Element) || !event.target.closest('.customily-close-button')) return;
    finish();
    document.removeEventListener('click', onClose, true);
    // Let Customily close normally, then return keyboard and scroll focus to size.
    setTimeout(() => {
      const size = document.querySelector('select[name="options[Size]"]');
      const target = size || document.getElementById('customily-personalize-button');
      target?.focus({ preventScroll: true });
      target?.scrollIntoView({ block: 'center', behavior: 'instant' });
    }, 350);
  };
  document.addEventListener('click', onClose, true);
  const timer = setInterval(() => {
    if (++attempts > 100 || done) { clearInterval(timer); return; }
    const modal = document.querySelector('.customily-modal-container');
    const inlineSet = Array.from(document.querySelectorAll('.customily-set')).find(set =>
      !set.closest('.customily-modal-container') && set.querySelector('#mnbs-design-type,select[data-mnbs-styled="1"]') &&
      getComputedStyle(set).display !== 'none' &&
      getComputedStyle(set).visibility !== 'hidden' && set.getBoundingClientRect().width > 0);
    const opened = (modal && getComputedStyle(modal).display !== 'none' && modal.getBoundingClientRect().width > 0) || Boolean(inlineSet);
    const button = document.getElementById('customily-personalize-button');
    if (!opened && !autoOpened && button && !button.disabled && button.getBoundingClientRect().width > 0) {
      autoOpened = true;
      button.click();
    }
    if (!opened) return;
    const selects = Array.from(document.querySelectorAll('#mnbs-design-type,#mnbs-speak-logo,.customily-set select'));
    if (!modeSet) {
      const match = value => isTemplate ? value === 'Speak Indigenous' : key === 'Official' ? /Official/.test(value) : new RegExp('^Nēhinawē ' + key + '(?: |$)').test(value);
      const input = selects.find(select => Array.from(select.options).some(option => match(option.value)));
      if (!input) return;
      change(input, Array.from(input.options).find(option => match(option.value)).value);
      modeSet = true;
      changedAt = Date.now();
      if (!isTemplate) { finish(); return; }
    }
    if (Date.now() - changedAt < 800) return;
    const matchLogo = value => new RegExp('^' + key + '\\s*[-–—]').test(value);
    const input = selects.find(select => Array.from(select.options).some(option => matchLogo(option.value)));
    if (!input) return;
    change(input, Array.from(input.options).find(option => matchLogo(option.value)).value);
    finish();
  }, 300);
  window.addEventListener('pagehide', () => {
    clearInterval(timer);
    document.removeEventListener('click', onClose, true);
  }, { once: true });
}());
